import { unwrap } from '@/lib/apiEnvelope'
import { httpClient } from '@/lib/httpClient'
import { UPLOAD_TIMEOUT_MS } from '@/lib/upload'
import type { ApiResponse } from '@/types/api'

import type { Payslip, PayslipUpload } from '../types/payslip'

export const payslipApi = {
  /** Contracheques do colaborador logado (identificado pelo token). */
  listMine: async (): Promise<Payslip[]> => {
    const response = await httpClient.get<ApiResponse<Payslip[]>>('/meus-contracheques')
    return unwrap(response)
  },
  /** Visão do RH/Diretoria — 403 para o colaborador comum. */
  listByEmployee: async (colaboradorId: string): Promise<Payslip[]> => {
    const response = await httpClient.get<ApiResponse<Payslip[]>>(
      `/Colaborador/${colaboradorId}/contracheques`,
    )
    return unwrap(response)
  },
  create: async (colaboradorId: string, payload: PayslipUpload): Promise<Payslip> => {
    const response = await httpClient.post<ApiResponse<Payslip>>(
      `/Colaborador/${colaboradorId}/contracheques`,
      payload,
      { timeout: UPLOAD_TIMEOUT_MS },
    )
    return unwrap(response)
  },
}
